import { defineMessages } from 'react-intl';

export default defineMessages({
  byline: {
    id: 'frontbucket.branches.byline',
    description: 'Byline text on the branches page for small screens',
    defaultMessage: 'Updated by',
  },
  dateText: {
    id: 'frontbucket.branches.dateText',
    description: 'Last updated text on the branches page for screen readers',
    defaultMessage: '{branchName}, Updated, {relativeDate}',
  },
});
